// @flow

import Wysiwyg from './wysiwyg';
import wysiwygWithMacros from './wysiwygWithMacros';

export type {
  ACFProps,
} from './wysiwyg';

export {
  wysiwygWithMacros,
};

export default Wysiwyg;
